import Layout from "@components/molecules/layout";
import UserRating from "@components/organisms/user-rating";
import UserReview from "@components/organisms/user-review";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ContentRenderProps } from "./review.type";

const Review = () => {
  const navigate = useNavigate();

  const [contentRender, setContentRender] = useState<ContentRenderProps>({
    userReview: false,
    userRating: true,
  });

  const handleUserReviewBack = () => {
    setContentRender({ userReview: false, userRating: true });
  };

  const handleUserRatingNext = () => {
    setContentRender({ userReview: true, userRating: false });
  };

  const handleUserRatingBack = () => {
    navigate("/game-details");
  };

  return (
    <Layout isLayout={false}>
      {contentRender.userRating ? (
        <UserRating
          handelNext={handleUserRatingNext}
          handleBack={handleUserRatingBack}
        />
      ) : (
        <UserReview
          handleBack={handleUserReviewBack}
          handelNext={handleUserRatingBack}
        />
      )}
    </Layout>
  );
};

export { Review };
